import {
  Autocomplete,
  Box,
  Breadcrumbs,
  CircularProgress,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Paper,
  TextField,
  Grid,
} from "@mui/material";
import { Container } from "react-bootstrap";
import Section from "../components/mobile screen/sections/section";

import { useEffect, useRef, useState } from "react";
import {
  generateRandomToken,
  getLocalStorageMenuItem,
  removeLocalStorageMenuItem,
  setLocalStorageMenuItem,
  setMobileBackColor,
  setMobileButttonBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileSettings,
  setMobileTextColor,
  setMobileTextField_BK_FONT_Border_StyleColor,
} from "../utility";
import axios from "axios";
import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import Top from "../components/mobile screen/sections/Top";
import { useQuery } from "react-query";
import coverSample from "../images/No_Image_Available.jpg";
import "../css/mobileScreens.css";
import DishFullRow from "../components/mobile screen/sections/dishFullRow";
import {
  ArrowDropDownOutlined,
  ArrowLeft,
  ArrowRight,
  CloseRounded,
  TuneOutlined,
} from "@mui/icons-material";
import Toast from "../common/toast";
import SendOrderButton from "../components/mobile screen/sendOrderButton";
import i18next, { t } from "i18next";
import { InputLabel, Popper, Select } from "@mui/material";
import Loading from "../common/loading";
import FloatingChatButton from "../components/mobile screen/mobileComponents/FloatingChatButton";
import LoadingTreeDataDialog from './../components/mobile screen/mobileComponents/LoadingTreeDataDialog';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BottomNavBar from "../components/BottomNavBar";

const Sections = ({ tableQr, tableName }) => {
  const [loadingTree, setLoadingTree] = useState(false);
  const [loading, setLoading] = useState(true);

  const [params, setParams] = useSearchParams();
  const [allTreeData, setAllTreeData] = useState(getLocalStorageMenuItem("tree_data") || [])
  const [renderKey, setRenderKey] = useState(0);
  const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Responsive breakpoints
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    // Restore scroll position if returning from item page
    if (location.state?.restoreScroll) {
      const scrollPosition = parseInt(location.state.scrollPosition || getLocalStorageMenuItem('itemScrollPosition') || '0');

      setTimeout(() => {
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
        // Clear the stored position
        removeLocalStorageMenuItem('itemScrollPosition');
      }, 100);
    }
  }, [location.state]);



  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const checkMobilePayment = async () => {
    if (params.get("success")) {
      if (params.get("success") === "true" || params.get("success") === "1") {
        handleOpenToast(
          <div className="alignByLang">
            {t("Payemnt process done successfully")}
          </div>
          , true);
      } else {
        handleOpenToast(
          <div className="alignByLang">
            {t("Error in payment process")}
          </div>
          , false);
      }
    }
  }

  const handleActionInFloatingChatButton = (updateAction) => {
    if (updateAction) {
      setRenderKey((prevKey) => prevKey + 1);
    }
  };

  const loadTree = async () => {
    setLoadingTree(true);
    try {
      const timeZone = getLocalStorageMenuItem("timezone") || "";
      const promise = await axios.get(
        `${process.env.REACT_APP_API}/menus/${tableQr}/public-tree?table=${params.get('t') || null}`,
        {
          headers: {
            localization: getLocalStorageMenuItem("lang") || "",
            timeZone: timeZone.replace(/["]+/g, ''),
          },
        }
      );
      if (promise?.data?.data?.length === 0 || !promise?.data?.data?.details || !promise?.data?.data?.tree || !promise?.data?.data?.items) {
        setLoadingTreeDialog(true);
      }
      setAllTreeData(promise?.data?.data || [])
      setLocalStorageMenuItem(
        "tree_data",
        JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
      );
      setMobileSettings(promise?.data?.data?.details)
      return promise?.data?.data;
    } catch (error) {
      // Handle error
    } finally {
      setLoadingTree(false);
    }
  }

  const loadTreeData = async () => {
    if (allTreeData.length === 0 || !allTreeData.details || !allTreeData.tree || !allTreeData.items) {
      loadTree();
    } else {
      const pathname = location.pathname;
      const pathSegments = pathname.split('/');
      const menu_code_number = pathSegments[2];
      const treeMenu_code_number = allTreeData?.details?.code_number;
      if (menu_code_number !== treeMenu_code_number) {
        loadTree();
      }
    }
  };

  const { qrName, qrCode } = useParams();
  const divRef = useRef(null);
  const [divWidth, setDivWidth] = useState(null);
  const [sectionNumber, setSectionNumber] = useState(params.get("section"));
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });

  const [currentSectionId, setCurrentSectionId] = useState(-1);
  const sectionRefs = useRef([]);
  const [scrollPositions, setScrollPositions] = useState({});

  var lang = getLocalStorageMenuItem("lang");

  useEffect(() => {
    const initializeLanguage = async () => {
      lang = getLocalStorageMenuItem("lang");

      if (!lang) {
        lang = params.get("lang");
        if (lang) {
          setLocalStorageMenuItem("lang", lang);
        } else {
          lang = 'en';
        }
      }

      await i18next.changeLanguage(lang);
      setLoading(false);
    };

    initializeLanguage();
  }, [params]);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const handleClickLabel = (label_name) => {
    navigate(
      `/${qrName}/${qrCode}/labels?label_name=${label_name}&t=${params.get(
        "t"
      )}&lang=${lang}&section=${params.get("section")}`,
      { replace: true }
    );
  };

  useEffect(() => {
    loadTreeData();
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 140;
      sectionRefs.current.forEach((ref, index) => {
        if (ref && ref.offsetTop <= scrollPosition) {
          setCurrentSectionId(index);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const updateTreeData = (newTreeData) => {
    setAllTreeData(newTreeData)
  }

  const handleSectionClick = (index) => {
    const section = sectionRefs.current[index];
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 140,
        behavior: "smooth",
      });
    }
    setCurrentSectionId(index);
  };

  const handleSectionClickWithBack = async (index) => {
    params.set('section', 0);
    setCurrentSectionId(index)
    await setParams(params);
    setTimeout(() => {
      const section = sectionRefs.current[index];
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 140,
          behavior: "smooth",
        });
      }
      setCurrentSectionId(index);
    }, 500);
  };

  const handleBreadcrumbSectionClick = async (index, sectionId) => {
    const breadcrumbsLength = data?.data?.data?.details?.breadcrumbs?.length || 0;
    if (index === breadcrumbsLength - 1) {
      return true
    }
    params.set('section', 0);
    await setParams(params);
    sectionsRefetch();

    setTimeout(() => {
      const section = sectionRefs.current[sectionId];
      if (section) {
        window.scrollTo({
          top: section.offsetTop - 140,
          behavior: "smooth",
        });
      }
      setCurrentSectionId(sectionId);
    }, 500);
  };

  const fetchFun = () => {
    if (params.get("section") !== "0" && params.get("section") !== "null") {
      return axios.get(
        `${process.env.REACT_APP_API
        }/menus/${qrCode}/public-section?section_id=${params.get("section") || null}`,
        { headers: { localization: getLocalStorageMenuItem("lang") } }
      );
    }
  };

  const { data, isLoading, isFetching, isError, isPreviousData, refetch: sectionsRefetch, } = useQuery(
    ["mainSections", params.get("section"), getLocalStorageMenuItem("lang")],
    fetchFun
  );

  useEffect(() => {
    // Restore scroll to specific section when navigating back from subsection
    const scrollToSectionId = getLocalStorageMenuItem('scrollToSectionId');

    if (scrollToSectionId) {
      setTimeout(() => {
        // Try to find the section element by data-section-id attribute
        const sectionElement = document.querySelector(`[data-section-id="${scrollToSectionId}"]`);

        if (sectionElement) {
          const offsetTop = sectionElement.offsetTop - 140; // Account for header
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth',
          });
        }

        // Clear the stored section ID
        removeLocalStorageMenuItem('scrollToSectionId');
      }, 300); // Wait for DOM to update
    }
  }, [params.get("section"), data]);

  const {
    data: itemsData,
    isLoading: itemsIsLoading,
    isFetching: itemsIsFetching,
    isError: ItemsIsError,
    error: itemsError,
    refetch: itemsRefetch,
  } = useQuery("items", () => {
    try {
      return axios.get(
        `${process.env.REACT_APP_API}/menus/${qrCode}/public-search`,
        { headers: { localization: getLocalStorageMenuItem("lang") } }
      );
    } catch (error) {
      console.error("Error fetching items:", error);
      return [];
    }
  });

  const handleItem = (event, value) => {
    if (value.id) {
      navigate(`/${qrName}/${qrCode}/items?item=${value.id}&selectedLang=${getLocalStorageMenuItem("lang")}`, {
        replace: true
      });
    }
  };

  const handleLanguage = async (lang) => {
    i18next.changeLanguage(lang);
    document.querySelector("html").lang = lang;
    setLocalStorageMenuItem("lang", lang);
    params.set("lang", lang);
    if (lang === "ar" || lang === "fa") {
      document.body.classList.remove("latino-font");
      document.body.classList.add("arabic-font");
    } else {
      document.body.classList.add("latino-font");
      document.body.classList.remove("arabic-font");
    }
    setParams(params);
  };

  const handleParentSection = (section) => {
    const currentScrollPosition = window.scrollY;
    setLocalStorageMenuItem('itemScrollPosition', currentScrollPosition.toString());
    if (section.parent_id) {
      if (section.id) {
        setSectionNumber(section.id);
        params.set("section", section.id || 0);
        setParams(params);
      } else {
        setSectionNumber(0);
        params.set("section", 0);
        setParams(params);
      }
    } else {
      setSectionNumber(0);
      params.set("section", 0);
      setParams(params);
    }
    window.scrollTo(0, 0);
  };

  const handleSectionScroll = (el, index) => {
    sectionRefs.current[index] = el;
  }

  // const handleParent = () => {
  //   if (data?.data?.data?.details.parent_id) {
  //     setSectionNumber(data?.data?.data?.details.parent_id);
  //     params.set("section", data?.data?.data?.details.parent_id || 0);

  //   } else {
  //     setSectionNumber(0);
  //     params.set("section", 0);
  //   }
  //   setParams(params);
  // };

  const handleParent = () => {
    if (data?.data?.data?.details.parent_id) {
      const parentSectionId = data?.data?.data?.details.parent_id;

      // Store the parent section ID to scroll to it after navigation
      setLocalStorageMenuItem('scrollToSectionId', parentSectionId.toString());

      setSectionNumber(0);
      params.set("section", 0);
    } else {
      setSectionNumber(0);
      params.set("section", 0);
    }
    setParams(params);
  };

  const backToMain = () => {
    setSectionNumber(0);
    params.set("section", 0);
    setParams(params);
  };

  const onImageError = (e) => {
    e.target.src = coverSample;
  };

  const handleFavorite = (item) => {
    const index = favorites.findIndex((fav) => fav.id === item.id);
    if (index === -1) {
      const newFavorites = [...favorites, item];
      setFavorites(newFavorites);
      setLocalStorageMenuItem("favorites", JSON.stringify(newFavorites));
      handleOpenToast(t("Added to favorites"));
    } else {
      const newFavorites = favorites.filter(
        (favItem) => favItem.id !== item.id
      );
      setFavorites(newFavorites);
      setLocalStorageMenuItem("favorites", JSON.stringify(newFavorites));
      handleOpenToast(t("Removed from favorites"));
    }
  };

  const { data: favoritesData, isLoading: favoritesIsLoading } = useQuery(
    "favorites",
    async () => {
      const favoritesFromCookie = getLocalStorageMenuItem("favorites");
      if (favoritesFromCookie) {
        const favoritesItems = favoritesFromCookie;
        const favoritesArray = favoritesItems?.map((item) => item.id);
        const promise = await axios.get(
          `${process.env.REACT_APP_API
          }/menus/${qrCode}/favourites?items=${JSON.stringify(favoritesArray)}`,
          { headers: { localization: lang } }
        );
        setFavorites(favoritesFromCookie);
        return promise;
      }
      setFavorites([]);
      return [];
    }
  );

  useEffect(() => {
    if (divRef.current) {
      const width = divRef.current.offsetWidth;
      setDivWidth(width);
    }
  });

  const handleOpenToast = (message) => {
    const toast = { ...toastSettings };
    toast.open = true;
    toast.success = true;
    toast.message = message;
    setToastSettings(toast);
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToastSettings({ open: false, message: "", success: false });
  };

  useEffect(() => {
    checkMobilePayment();
    if (!getLocalStorageMenuItem("gustToken")) {
      setLocalStorageMenuItem("gustToken", generateRandomToken(25));
    }
    document.body.style.direction = "ltr";
  }, []);

  function CustomPopper(props) {
    return <Popper {...props} placement="top-start" disablePortal={true} />;
  }

  // Helper function to render main sections with their subsections
  const renderMainSectionsWithSubsections = () => {
    if (!allTreeData?.tree) return null;

    return Object.values(allTreeData.tree).map((mainSection, mainIndex) => {
      if (!mainSection.active) return null;

      const hasSubsections = Array.isArray(mainSection?.children?.sections) &&
        mainSection?.children?.sections?.length > 0;
      const hasItems = Array.isArray(mainSection?.children?.items) &&
        mainSection?.children?.items?.length > 0;

      return (
        <div data-section-id={mainSection.id} key={mainSection.id} className="main-section-container mb-4">
          {/* Main Section - Full Row */}
          <div className="main-section-row mb-3">
            <Grid container>
              <Grid item xs={12}>
                <Section
                  section={mainSection}
                  handleSectionScroll={(el) => handleSectionScroll(el, mainIndex)}
                  handleParentSection={handleParentSection}
                  disabledFlag={1}
                  isMobile={isMobile}
                  isDesktop={isDesktop}
                  isMainSection={true}
                />
              </Grid>
            </Grid>
          </div>

          {/* Subsections Grid */}
          {hasSubsections && (
            <div className="subsections-container mb-3">
              <Grid width={"100%"} container spacing={isDesktop ? 3 : 2} justifyContent={"center"}>
                {Object.values(mainSection.children.sections).map((subsection, subIndex) =>
                  subsection.active ? isDesktop ? (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={subsection.id}>
                      <Section
                        section={subsection}
                        parentSectionName={mainSection.name}
                        handleSectionScroll={(el) => handleSectionScroll(el, subIndex)}
                        handleParentSection={handleParentSection}
                        disabledFlag={0}
                        isMobile={isMobile}
                        isDesktop={isDesktop}
                        isSubSection={true}
                      />
                    </Grid>
                  ) : <Section
                    section={subsection}
                    parentSectionName={mainSection.name}
                    handleSectionScroll={(el) => handleSectionScroll(el, subIndex)}
                    handleParentSection={handleParentSection}
                    disabledFlag={0}
                    isMobile={isMobile}
                    isDesktop={isDesktop}
                    isSubSection={true}
                  /> : null
                )}
              </Grid>
            </div>
          )}

          {/* Items Grid */}
          {hasItems && (
            <div className="items-container mt-3">
              <Grid container spacing={isDesktop ? 3 : 2}>
                {mainSection.children.items.map((item) =>
                  item.active ? (
                    <Grid item xs={12} sm={6} md={4} lg={isDesktop ? 3 : 4} key={item.id}>
                      <DishFullRow
                        in_root={true}
                        item={item}
                        qrCode={qrCode}
                        qrName={qrName}
                        sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
                        handleFavorite={handleFavorite}
                        favorites={favorites}
                        suggested={false}
                        not_menu_availability={!allTreeData?.details?.is_available || !allTreeData?.details || !allTreeData?.tree || !allTreeData?.items}
                        isMobile={isMobile}
                        isDesktop={isDesktop}
                      />
                    </Grid>
                  ) : null
                )}
              </Grid>
            </div>
          )}
        </div>
      );
    });
  };

  if (loading || loadingTree) {
    return <Loading backColor={setMobileBackColor()} />;
  }

  return (
    <div
      className={`min-vh-100`}
      style={{ backgroundColor: setMobileBackColor() }}
    >
      <Container fluid >
        <div className="row">
          <div className={`p-0 m-0 ${isDesktop ? "col-12" : "ms-auto"}`}>
            <div
              className={`${isDesktop ? "desktop-screen" : "mobile-side-screen"}`}
              style={{ marginBottom: isMobile ? "65px" : "0px" }}
              ref={divRef}
            >
              {params.get("section") != 0 ?
                <Top
                  order_ability={allTreeData?.details?.order_ability || false}
                  currentId={params.get("section")}
                  currentSectionId={currentSectionId}
                  parentId={data?.data?.data?.details?.parent_id}
                  mianSectionsData={{ tree: allTreeData }}
                  qrCode={qrCode}
                  qrName={qrName}
                  handleLanguage={handleLanguage}
                  updateTreeData={(newtree) => updateTreeData(newtree)}
                  handleOnClick={(index) => handleSectionClickWithBack(index)}
                  detailsData={allTreeData?.details}
                  lablesData={allTreeData?.labels}
                  label_name={null}
                  handleParent={handleParent}
                  backToMain={backToMain}
                  width={divWidth}
                  itemsRefetch={itemsRefetch}
                  isMobile={isMobile}
                  isDesktop={isDesktop}
                />
                :
                <Top
                  order_ability={allTreeData?.details?.order_ability || false}
                  currentId={params.get("section")}
                  currentSectionId={currentSectionId}
                  parentId={data?.data?.data?.details?.parent_id}
                  mianSectionsData={{ tree: allTreeData }}
                  qrCode={qrCode}
                  qrName={qrName}
                  handleLanguage={handleLanguage}
                  updateTreeData={(newtree) => updateTreeData(newtree)}
                  handleOnClick={(index) => handleSectionClick(index)}
                  detailsData={allTreeData?.details}
                  lablesData={allTreeData?.labels}
                  label_name={null}
                  handleParent={handleParent}
                  backToMain={backToMain}
                  width={divWidth}
                  itemsRefetch={itemsRefetch}
                  isMobile={isMobile}
                  isDesktop={isDesktop}
                />
              }

              <div className="sections">
                <div className={`sections-content ${isDesktop ? "px-4" : ""}`} style={{ minHeight: "100vh" }}>
                  {/* Search and Filter Section */}
                  <div className={`alignByLang ${isDesktop ? "d-flex justify-content-between align-items-center mb-4" : "d-flex align-items-center"}`}>
                    {isDesktop && data?.data?.data?.details.breadcrumbs && (
                      <div className="fw-bold head-font alignByLang">
                        <Breadcrumbs
                          separator={
                            getLocalStorageMenuItem("lang") === "ar" ||
                              getLocalStorageMenuItem("lang") === "fa" ? (
                              <ArrowLeft
                                className={`cursor`}
                                style={{ color: setMobileTextColor() }}
                              />
                            ) : (
                              <ArrowRight
                                className={`cursor`}
                                style={{ color: setMobileTextColor() }}
                              />
                            )
                          }
                        >
                          {data?.data?.data?.details?.breadcrumbs?.map(
                            (section, index) => (
                              <Link
                                key={section.id}
                                className="meta-path"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  textDecoration: "none",
                                }}
                                color="inherit"
                                onClick={() => handleBreadcrumbSectionClick(index, currentSectionId)}
                              >
                                {index ===
                                  data?.data?.data?.details.breadcrumbs.length -
                                  1 &&
                                  data?.data?.data?.details.breadcrumbs.length > 1 ? (
                                  <strong
                                    className="sub-font cursor"
                                    style={{
                                      textDecoration: "none",
                                      color: setMobileButttonBackColor(),
                                    }}
                                  >
                                    {t(section.name)}
                                  </strong>
                                ) : (
                                  <strong
                                    className="sub-font cursor"
                                    style={{
                                      textDecoration: "none",
                                      color: setMobileTextColor(),
                                    }}
                                  >
                                    {t(section.name)}
                                  </strong>
                                )}
                              </Link>
                            )
                          )}
                        </Breadcrumbs>
                      </div>
                    )}

                    <div className={`${isDesktop ? "d-flex align-items-center w-100" : "d-flex align-items-center w-100"} mt-3`}>
                      <div className={`d-flex align-items-center w-100 justify-content-center`}
                      >
                        <IconButton
                          aria-label="filter"
                          onClick={handleFilterClick}
                          style={getLocalStorageMenuItem("lang") === "ar" ||
                            getLocalStorageMenuItem("lang") === "fa" ? { marginRight: "8px" } : { marginLeft: "8px" }}
                        >
                          <TuneOutlined sx={{ color: setMobileTextColor() }} />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleFilterClose}
                          sx={{
                            '& .MuiPaper-root': {
                              backgroundColor: setMobileCardColor(),
                              width: isMobile ? '100%' : 'auto',
                              textAlign: "center"
                            },
                          }}
                          style={{ textAlign: "center" }}
                        >
                          {allTreeData?.labels?.map((label, index) =>
                            label.count > 0 ? (
                              <MenuItem
                                key={index}
                                sx={{
                                  textAlign: "center",
                                  backgroundColor: setMobileCardColor(),
                                  color: setMobileTextColor(),
                                  justifyContent: "center",
                                  width: "100%",
                                  '&:hover': {
                                    backgroundColor: setMobileBackColor(),
                                  },
                                  fontFamily:
                                    getLocalStorageMenuItem("lang") === "ar" ||
                                      getLocalStorageMenuItem("lang") === "fa"
                                      ? "Almarai"
                                      : "Roboto",
                                }}
                                style={{ textAlign: "center" }}
                                onClick={() => handleClickLabel(label.name)}
                              >
                                {t(label.name)}
                              </MenuItem>
                            ) : null
                          )}
                        </Menu>

                        <Autocomplete
                          className={`${isMobile ? "w-100" : "w-50"} rounded-2 MuiInputBase-root sub-font`}
                          id="asynchronous-demo"
                          style={{
                            borderWidth: 1,
                            borderStyle: "solid",
                            backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor()[0],
                            color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
                            borderColor: setMobileTextField_BK_FONT_Border_StyleColor()[2],
                            borderRadius: "8px",
                            height: "44px",
                            fontSize: "16px",
                            fontWeight: 400,
                            minWidth: isDesktop ? "300px" : "auto",
                          }}
                          sx={{
                            "& .MuiInputBase-root": {
                              color: setMobileTextField_BK_FONT_Border_StyleColor()[1],
                            },
                            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: setMobileCardBorderColor(),
                            },
                          }}
                          placeholder="Search for menu"
                          PaperComponent={(props) => (
                            <Paper
                              className="sub-font"
                              sx={{
                                backgroundColor: setMobileBackColor(),
                                color: setMobileTextColor(),
                                fontSize: "14px",
                                "& .MuiAutocomplete-noOptions": {
                                  backgroundColor: setMobileCardColor(),
                                  color: setMobileTextColor(),
                                },
                                "& .MuiAutocomplete-option": {
                                  backgroundColor: setMobileCardColor(),
                                  color: setMobileTextColor(),
                                  fontFamily:
                                    getLocalStorageMenuItem("lang") === "ar" ||
                                      getLocalStorageMenuItem("lang") === "fa"
                                      ? "Almarai"
                                      : "Roboto",
                                },
                              }}
                              {...props}
                            />
                          )}
                          clearIcon={<CloseRounded sx={{ color: setMobileTextColor() }} />}
                          popupIcon={<ArrowDropDownOutlined sx={{ color: setMobileTextColor() }} />}
                          open={open}
                          onOpen={() => {
                            !itemsIsLoading && setOpen(true);
                          }}
                          onClose={() => {
                            setOpen(false);
                          }}
                          isOptionEqualToValue={(option, value) => option.title === value.label}
                          onChange={handleItem}
                          getOptionLabel={(option) => option.label}
                          options={itemsData?.data?.map((item) => {
                            return { id: item.id, label: item.name };
                          })}
                          loading={itemsIsLoading}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              className="alignByLang sub-font"
                              placeholder={t("Search....")}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>
                                    {itemsIsLoading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </>
                                ),
                              }}
                              sx={{
                                "input::placeholder": {
                                  fontFamily:
                                    getLocalStorageMenuItem("lang") === "ar" ||
                                      getLocalStorageMenuItem("lang") === "fa"
                                      ? "Almarai"
                                      : "Roboto",
                                },
                                "& input": {
                                  fontFamily:
                                    getLocalStorageMenuItem("lang") === "ar" ||
                                      getLocalStorageMenuItem("lang") === "fa"
                                      ? "Almarai"
                                      : "Roboto",
                                },
                              }}
                            />
                          )}
                          PopperComponent={CustomPopper}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Breadcrumbs for Mobile */}
                  {!isDesktop && data && data?.data?.data?.details.breadcrumbs && (
                    <div className="ps-2 pe-2 m-top-12 mb-2 fw-bold head-font alignByLang">
                      <Breadcrumbs
                        separator={
                          getLocalStorageMenuItem("lang") === "ar" ||
                            getLocalStorageMenuItem("lang") === "fa" ? (
                            <ArrowLeft
                              className={`cursor`}
                              style={{ color: setMobileTextColor() }}
                            />
                          ) : (
                            <ArrowRight
                              className={`cursor`}
                              style={{ color: setMobileTextColor() }}
                            />
                          )
                        }
                      >
                        {data?.data?.data?.details?.breadcrumbs?.map(
                          (section, index) => (
                            <Link
                              key={section.id}
                              className="meta-path"
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                              }}
                              color="inherit"
                              onClick={() => handleBreadcrumbSectionClick(index, currentSectionId)}
                            >
                              {index ===
                                data?.data?.data?.details.breadcrumbs.length -
                                1 &&
                                data?.data?.data?.details.breadcrumbs.length > 1 ? (
                                <strong
                                  className="sub-font cursor"
                                  style={{
                                    textDecoration: "none",
                                    color: setMobileButttonBackColor(),
                                  }}
                                >
                                  {t(section.name)}
                                </strong>
                              ) : (
                                <strong
                                  className="sub-font cursor"
                                  style={{
                                    textDecoration: "none",
                                    color: setMobileTextColor(),
                                  }}
                                >
                                  {t(section.name)}
                                </strong>
                              )}
                            </Link>
                          )
                        )}
                      </Breadcrumbs>
                    </div>
                  )}

                  {/* Content Area */}
                  {params.get("section") != 0 ? isLoading ? (
                    <Box
                      className={`vh-100 w-100 h-100`}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: setMobileCardColor(),
                      }}
                    >
                      <CircularProgress sx={{ marginBottom: 25 }} />
                    </Box>
                  ) : (
                    <div className="mb-3 alignByLang">
                      <Grid container spacing={isDesktop ? 3 : 2}>
                        {data?.data?.data?.sections?.map(
                          (section, index) =>
                            section.active && (
                              <Grid item xs={12} sm={6} md={4} lg={3} key={section.id}>
                                <Section
                                  section={section}
                                  handleSectionScroll={(el) => handleSectionScroll(el, index)}
                                  handleParentSection={handleParentSection}
                                  disabledFlag={0}
                                  isMobile={isMobile}
                                  isDesktop={isDesktop}
                                />
                              </Grid>
                            )
                        )}
                      </Grid>

                      <Grid container spacing={isDesktop ? 3 : 2} className="mt-2">
                        {data?.data?.data?.items?.map(
                          (item) =>
                            item.active && (
                              <Grid item xs={12} sm={6} md={4} lg={isDesktop ? 3 : 4} key={item.id}>
                                <DishFullRow
                                  in_root={false}
                                  item={item}
                                  qrCode={qrCode}
                                  qrName={qrName}
                                  sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
                                  handleFavorite={handleFavorite}
                                  favorites={favorites}
                                  suggested={false}
                                  not_menu_availability={!allTreeData?.details?.is_available || !allTreeData?.details || !allTreeData?.tree || !allTreeData?.items}
                                  isMobile={isMobile}
                                  isDesktop={isDesktop}
                                />
                              </Grid>
                            )
                        )}
                      </Grid>
                    </div>
                  ) : (
                    <div className="mb-3 alignByLang">
                      {/* Render main sections with their subsections */}
                      {renderMainSectionsWithSubsections()}

                      <div style={{
                        height: !allTreeData?.details?.order_ability &&
                          !allTreeData?.details?.whatsapp ? "0px" : "50px"
                      }}></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Toast
          open={toastSettings.open}
          message={toastSettings.message}
          resetToast={handleCloseToast}
          success={toastSettings.success}
        />
        <FloatingChatButton
          qrCode={qrCode}
          qrName={qrName}
          sympole={allTreeData?.details?.currency_symbol ? allTreeData?.details?.currency_symbol : ""}
          handleFavorite={handleFavorite}
          favorites={favorites}
          suggested={false}
          onActionDone={handleActionInFloatingChatButton}
          treeData={allTreeData}
          isMobile={isMobile}
        />
        <LoadingTreeDataDialog openTreeDialogFlag={loadingTreeDialog} onClose={() => setLoadingTreeDialog(false)} tableName={tableName} tableQr={tableQr} from_home={false} />
      </Container>
      <BottomNavBar qr={tableQr} qrName={tableName} />
    </div>
  );
};

export default Sections;